/**
 * ============================================================
 * S3: custom-price-calculator.js
 * WholesaleTumblers — 动态价格明细 (v4)
 *
 * 功能:
 *   1. Quantity 右侧显示: Total: $xxx.xx (加粗) / $x.xx ea × qty (小字)
 *   2. 页面加载自动设置 Quantity = MOQ
 *   3. 联动 Dawn 原生价格显示（选变体时更新实际价格）
 *
 * 依赖:
 *   - window.__WT_PRICE_TIERS (由 S1 注入)
 *
 * 加载: layout/theme.liquid → </body> 前
 * 更新: 2026-05-13 v4
 * ============================================================
 */
(function() {
  'use strict';

  var DATA = window.__WT_PRICE_TIERS;
  if (!DATA || !DATA.tiers || !DATA.tiers.length) return;

  /* ── 工具函数 ── */

  function getBasePrice(vid) {
    for (var i = 0; i < DATA.variants.length; i++) {
      if (DATA.variants[i].id === vid) return DATA.variants[i].price;
    }
    return DATA.variants[0].price;
  }

  function getSelectedImprint(vid) {
    var idx = DATA.imprintOptionIndex;
    if (idx < 0) return 'Blank';
    for (var i = 0; i < DATA.variants.length; i++) {
      if (DATA.variants[i].id === vid) return DATA.variants[i].options[idx] || 'Blank';
    }
    return 'Blank';
  }

  function getSurcharge(name) {
    if (!DATA.surcharges) return 0;
    if (DATA.surcharges[name] !== undefined) return DATA.surcharges[name];
    var lower = name.toLowerCase();
    for (var k in DATA.surcharges) {
      if (k.toLowerCase() === lower) return DATA.surcharges[k];
    }
    return 0;
  }

  /* ── 动态在 Pill 变体按钮上追加 [+$X.XX] ── */
  function updateVariantLabels() {
    if (!DATA.surcharges) return;
    var fieldsets = document.querySelectorAll('fieldset.product-form__input');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && legend.textContent.trim().toLowerCase().indexOf('imprint') > -1) {
        var labels = fieldsets[i].querySelectorAll('label');
        for (var j = 0; j < labels.length; j++) {
          var inputId = labels[j].getAttribute('for');
          var input = document.getElementById(inputId);
          if (input) {
            var val = input.value;
            var surcharge = getSurcharge(val);
            if (surcharge > 0) {
              var existingSpan = labels[j].querySelector('.wt-surcharge-label');
              if (!existingSpan) {
                var span = document.createElement('span');
                span.className = 'wt-surcharge-label';
                // 使用 CSS 变量便于后续直接从控制台或 Liquid 切换两种方案
                span.style.fontSize = '0.7em';
                span.style.marginLeft = '0.4rem';
                span.style.opacity = '0.75';
                span.style.fontWeight = 'normal';
                
                // 默认展示方案 1 (带括号)
                span.innerHTML = '[+$' + surcharge.toFixed(2) + ']';
                // 如果想看方案 2 (无括号)，只需将上面这行改为: '+$' + surcharge.toFixed(2)
                
                labels[j].appendChild(span);
              }
            }
          }
        }
      }
    }
  }

  function getDiscount(qty) {
    var d = 0;
    for (var i = 0; i < DATA.tiers.length; i++) {
      if (qty >= DATA.tiers[i].qty) d = DATA.tiers[i].discount;
    }
    return d;
  }

  function getCurrentVariantId() {
    // 1. 最精确：直接从当前选中的 radios 获取
    var checked = document.querySelectorAll('variant-radios input[type="radio"]:checked, variant-selects select');
    var selectedOptions = [];
    for (var i = 0; i < checked.length; i++) {
      selectedOptions.push(checked[i].value);
    }
    if (selectedOptions.length > 0) {
      for (var j = 0; j < DATA.variants.length; j++) {
        var v = DATA.variants[j];
        var match = true;
        for (var k = 0; k < v.options.length; k++) {
          if (selectedOptions.indexOf(v.options[k]) === -1) { match = false; break; }
        }
        if (match) return v.id;
      }
    }
    
    // 2. URL fallback
    var p = new URLSearchParams(window.location.search);
    var v = p.get('variant');
    if (v) return parseInt(v, 10);
    
    // 3. Hidden input fallback
    var h = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (h) return parseInt(h.value, 10);
    
    return DATA.currentVariantId;
  }

  function fmt(n) { return '$' + n.toFixed(2); }

  /* ── 创建 UI ── */

  function createWidget() {
    var widget = document.createElement('div');
    widget.id = 'wt-custom-calc';
    widget.className = 'wt-price-calc';
    
    // We do NOT set flex-end here anymore, as the parent wrapper will handle layout
    widget.innerHTML = 
      '<div style="text-align: right;">' +
        '<div class="wt-price-calc__total-line" style="font-size: 1.6rem; font-weight: 700; line-height: 1.3; color: #1a1a1a;">' +
          '<span style="font-size: 1.1rem; margin-right: 0.5rem;">Total:</span>' +
          '<span id="wt-calc-total"></span>' +
        '</div>' +
        '<div id="wt-calc-detail" class="wt-price-calc__detail-line" style="font-size: 1.1rem; color: #555; margin-top: 0.5rem; line-height: 1.4;"></div>' +
        '<div id="wt-calc-save-row" class="wt-price-calc__save-line" style="display:none; font-size: 0.95rem; color: #15803d; font-weight: 600; margin-top: 0.2rem; line-height: 1.4;">' +
          'You Save: <span id="wt-calc-save"></span>' +
        '</div>' +
      '</div>';
      
    return widget;
  }

  /* ── 插入到 Quantity input 右侧 ── */

  function insertWidget(widget) {
    var qtyInput = document.querySelector('quantity-input');
    if (!qtyInput) return;
    
    var wrapper = document.getElementById('wt-price-calc-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.id = 'wt-price-calc-wrapper';
      wrapper.style.display = 'flex';
      wrapper.style.justifyContent = 'space-between';
      wrapper.style.alignItems = 'flex-end';
      wrapper.style.gap = '1.5rem';
      wrapper.style.maxWidth = '44rem';
      wrapper.style.marginBottom = '1.5rem';
      
      qtyInput.parentNode.insertBefore(wrapper, qtyInput);
      
      var leftBox = document.createElement('div');
      var label = document.querySelector('label[for="' + qtyInput.querySelector('input').id + '"]') || document.querySelector('label.form__label');
      if (label) leftBox.appendChild(label);
      leftBox.appendChild(qtyInput);
      
      wrapper.appendChild(leftBox);
    }

    wrapper.appendChild(widget);
  }

  /* ── 强制接管 Dawn 原生价格显示与 MOQ (对抗 AJAX 刷新) ── */
  var lastValidQty = DATA.moq;

  function enforceState() {
    var vid = getCurrentVariantId();
    var imprint = getSelectedImprint(vid);
    var targetMoq = DATA.moq;
    if (DATA.variant_moqs && DATA.variant_moqs[imprint]) {
       targetMoq = DATA.variant_moqs[imprint];
    }

    // 强制 MOQ & 记忆恢复
    var inp = document.querySelector('quantity-input input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    if (inp && targetMoq > 1) {
      var current = parseInt(inp.value, 10) || 1;
      
      if (current < targetMoq && document.activeElement !== inp) {
        // 如果 Dawn AJAX 强制重置为了 1，但我们之前记住了更大的数字，就恢复它
        var restoreQty = (lastValidQty >= targetMoq) ? lastValidQty : targetMoq;
        inp.value = restoreQty;
        inp.setAttribute('value', restoreQty);
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (current >= targetMoq) {
        // 只要当前输入是合法且有效的，就记录下来
        lastValidQty = current;
      }
    }
  }

  // 改为在 update() 中调用 enforceState，然后由 setInterval 定时刷新 update

  /* ── 更新计算 ── */

  function update() {
    enforceState(); // 每次更新前先强制纠正 Dawn 状态
    updateVariantLabels(); // 实时检查并注入变体加价标签
    
    // 如果 widget 丢失（被 Dawn AJAX 覆盖），则重新注入
    var calcEl = document.getElementById('wt-custom-calc');
    if (!calcEl) {
       insertWidget(createWidget());
    }

    var vid = getCurrentVariantId();
    var imprint = getSelectedImprint(vid);
    var targetMoq = DATA.moq;
    if (DATA.variant_moqs && DATA.variant_moqs[imprint]) {
       targetMoq = DATA.variant_moqs[imprint];
    }
    
    var qtyInput = document.querySelector('quantity-input input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || targetMoq) : targetMoq;

    var base = getBasePrice(vid);
    var imprint = getSelectedImprint(vid);
    var surcharge = getSurcharge(imprint);
    var discountPct = getDiscount(qty);

    var unitPrice = base * (1 - discountPct / 100);
    var subtotal = unitPrice * qty;
    var fullPrice = base * qty;
    var youSave = fullPrice - subtotal;

    var elTotal = document.getElementById('wt-calc-total');
    var elDetail = document.getElementById('wt-calc-detail');
    var elSave = document.getElementById('wt-calc-save');
    var elSaveRow = document.getElementById('wt-calc-save-row');

    if (elTotal) elTotal.textContent = fmt(subtotal);
    if (elDetail) elDetail.textContent = fmt(unitPrice) + ' ea × ' + qty + ' qty';

    if (youSave > 0.005 && elSave && elSaveRow) {
      elSave.textContent = fmt(youSave);
      elSaveRow.style.display = '';
    } else if (elSaveRow) {
      elSaveRow.style.display = 'none';
    }

    // 同步 Dawn 原生价格（显示含 surcharge 的实际单价）
    // updateDawnPrice(base + surcharge);  // 已经被原生替代，不需要这段代码了
  }

  /* ── 初始化 ── */

  var widget = createWidget();
  insertWidget(widget);
  update();
  
  // 以 100ms 频率不断纠正 DOM 和更新计算器
  setInterval(update, 100);

  // 监听 quantity
  var qtyInput = document.querySelector('input[name="quantity"]');
  if (qtyInput) {
    qtyInput.addEventListener('input', update);
    qtyInput.addEventListener('change', update);
  }

  // 监听 variant radio
  var radios = document.querySelectorAll('fieldset input[type="radio"]');
  for (var r = 0; r < radios.length; r++) {
    radios[r].addEventListener('change', function() { setTimeout(update, 50); });
  }

  // URL popstate
  window.addEventListener('popstate', function() { setTimeout(update, 50); });

  // MutationObserver on hidden variant input
  var hiddenId = document.querySelector('input[name="id"]');
  if (hiddenId) {
    new MutationObserver(function() { update(); })
      .observe(hiddenId, { attributes: true, attributeFilter: ['value'] });
  }

  // ====== 追加选项选中值到标题 (e.g. Imprint: Blank) ======
  function updateLegendText(fieldset) {
    var checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    var legend = fieldset.querySelector('legend.form__label');
    
    // 如果找到了选中的按钮和对应的标题，且它不是 Shopify 原生的色块(原生自带该功能)
    if (checkedInput && legend && !legend.querySelector('[data-selected-swatch-value]')) {
      // 提取原标题名 (比如 "Imprint")，以防重复叠加
      var optionName = legend.textContent.split(':')[0].trim();
      legend.innerHTML = optionName + ': <span style="font-weight: normal; margin-left: 4px;" class="custom-selected-value">' + checkedInput.value + '</span>';
    }
  }

  // 1. 页面加载时初始化所有选项
  var fieldsets = document.querySelectorAll('fieldset');
  for (var f = 0; f < fieldsets.length; f++) {
    var hasRadio = fieldsets[f].querySelector('input[type="radio"]');
    if (hasRadio) {
      updateLegendText(fieldsets[f]);
    }
  }

  // 2. 监听用户点击切换选项
  document.addEventListener('change', function(e) {
    if (e.target && e.target.tagName === 'INPUT' && e.target.type === 'radio') {
      var fieldset = e.target.closest('fieldset');
      if (fieldset) {
        // 给一点点延迟，确保 Shopify 的原生 JS 更新完 (如果有的话)
        setTimeout(function() { updateLegendText(fieldset); }, 10);
      }
    }
  });

})();
